module.exports = {"top3":["Adults with inappropriate lower back imaging","Uninsured children","Alcohol deaths"],"bottom3":["Medicare spending per beneficiary","Adults without a dental visit","Employee insurance costs as a share of median income"],"most_improved":["Nursing home residents with an antipsychotic medication","Uninsured adults","Home health patients without improved mobility"],"most_declined":["Preventable hospitalizations ages 18-64","Adults without all recommended vaccines","Employee insurance costs as a share of median income"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/LA.json
// module id = 258
// module chunks = 143196823979170 184088790168614